// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-PageLayout-PageLayout-module__pageLayout--RRlbz {
  height: 100%;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.src-components-PageLayout-PageLayout-module__pageContent--Q5cdl {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  flex: 1;
}
/*# sourceMappingURL=PageLayout.module.css.map */`, "",{"version":3,"sources":["webpack://./PageLayout.module.less","webpack://./src/components/PageLayout/PageLayout.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;ACCF;ADEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,OAAA;ACAF;AACA,gDAAgD","sourcesContent":[".pageLayout {\n  height: 100%;\n  width: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.pageContent {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: auto;\n  flex: 1;\n}\n",".pageLayout {\n  height: 100%;\n  width: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n.pageContent {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: auto;\n  flex: 1;\n}\n/*# sourceMappingURL=PageLayout.module.css.map */"],"sourceRoot":""}]);
// Exports
export var pageLayout = `src-components-PageLayout-PageLayout-module__pageLayout--RRlbz`;
export var pageContent = `src-components-PageLayout-PageLayout-module__pageContent--Q5cdl`;
export default ___CSS_LOADER_EXPORT___;
